/* @flow */

import React from 'react';

import style from './index-module.css';

const Card: Function = ({ children, className }): React$Element<*> => (
  <div className={`${style.container} ${className || ''}`}>
    {children}
  </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/card/index.js